<template lang="pug">
  div()
    app-header(class='u-bg-primary' wrapper-class='u-bg-primary', :white='true')

    div(class='u-pt5 u-bg-landscape')
      h2(class='u-center u-mt0 u-fz-h1 u-line-1  o-wrapper')
        span(class='u-fw-light') Libro de&nbsp;
        strong(class='u-color-secondary') Reclamaciones

      section(class=' o-wrapper u-mb5')
        label(class='u-fw-bold u-color-primary u-block u-mb3 u-fz-h4') Selecciona una opción:
        div(class='u-flex u-flex-wrap')
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='claim1' type='radio' name='claimOptionId' class='u-mr2', :value='1' v-model='form.claimOptionId')
            label(class='c-input__label' for='claim1') Reclamo
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='claim2' type='radio' name='claimOptionId' class='u-mr2', :value='2' v-model='form.claimOptionId')
            label(class='c-input__label' for='claim2') Queja
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='claim3' type='radio' name='claimOptionId' class='u-mr2', :value='3' v-model='form.claimOptionId')
            label(class='c-input__label' for='claim3') Consulta

      section(class=' o-wrapper u-mb5')
        label(class='u-fw-bold u-color-primary u-block u-mb3 u-fz-h4') 1. Datos personales
        input-validate(
          v-model='form.person.fullname', :rule='rules.person.fullname' placeholder='Nombres y apellidos', :validation='toggleValidate'
          class='u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        input-validate(
          v-model='form.person.legalName', :rule='rules.person.legalName' placeholder='Razón Social', :validation='toggleValidate'
          class='u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        input-validate(
          v-model='form.person.address', :rule='rules.person.address' placeholder='Dirección', :validation='toggleValidate'
          class='u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        div(class=' u-flex-wrap u-flex')
          input-validate(
            v-model='form.person.district', :rule='rules.person.district' placeholder='Distrito', :validation='toggleValidate'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(
            v-model='form.person.province', :rule='rules.person.province' placeholder='Provincia', :validation='toggleValidate'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(
            v-model='form.person.region', :rule='rules.person.region' placeholder='Departamento', :validation='toggleValidate'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(
            v-model='form.person.identityDocument', :rule='rules.person.identityDocument' placeholder='Documento de identidad', :validation='toggleValidate'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(
            v-model='form.person.phone', :rule='rules.person.phone' placeholder='Teléfono fijo', :validation='toggleValidate' type='tel'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(
            v-model='form.person.cellphone', :rule='rules.person.cellphone' placeholder='Telefonía móvil', :validation='toggleValidate' type='tel'
            class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        input-validate(
          v-model='form.person.email', :rule='rules.person.email' placeholder='Correo electrónico', :validation='toggleValidate' type='email'
          class='u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        div(class=' u-flex-wrap u-flex')
          input-validate(
            v-model='form.person.parentsName', :rule='rules.person.parentsName' placeholder='Nombre del padre  y de la madre', :validation='toggleValidate' type='email'
            class='u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
          p(class='u-italic u-color-text u-show@tablet') ( En caso sea menor de edad )


      section(class=' o-wrapper u-mb5')
        label(class='u-fw-bold u-color-primary u-block u-mb3 u-fz-h4') 2. Identificación del bien contratado
        div(class='u-flex u-mb3')
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='contract1' type='radio' name='contract' class='u-mr2', :value='1' v-model='form.itemOptionId')
            label(class='c-input__label' for='contract1') Producto
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='contract2' type='radio' name='contract' class='u-mr2', :value='2' v-model='form.itemOptionId')
            label(class='c-input__label' for='contract2') Servicio

        input-validate(
          v-model='form.descriptionItem', :rule='rules.descriptionItem' placeholder='Descripción', :validation='toggleValidate' type='textarea'
          class='u-mb3 u-12/12  u-px3 c-input c-input--secondary' rows='5' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        input-validate(
          v-model='form.amount', :rule='rules.amount' placeholder='Monto reclamado', :validation='toggleValidate' type='text'
          class='u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')


      section(class=' o-wrapper u-mb5')
        label(class='u-fw-bold u-color-primary u-block u-mb3 u-fz-h4') 3. Detalles de la queja y/o reclamo, y pedido del consumidor:
        div(class='u-flex u-mb3 u-flex-wrap')
          input-validate(
            v-model='form.details', :rule='rules.details' placeholder='Detalles', :validation='toggleValidate' type='textarea'
            class='u-mb3 u-12/12 u-6/12@tablet u-px3 c-input c-input--secondary' rows='6' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
          input-validate(
            v-model='form.order', :rule='rules.order' placeholder='Pedido', :validation='toggleValidate' type='textarea'
            class='u-mb3 u-12/12 u-6/12@tablet u-px3 c-input c-input--secondary' rows='6' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

        file-validate(@update='updateFile', :clear='clearForm'
          class='u-px3 u-6/12@tablet u-12/12' label-class='u-italic u-fw-light u-mb2', :validation='toggleValidate'
          label='Documentos que sustenten la reclamación:' placeholder='Adjuntar archivo' wrapper-class='c-input c-input--secondary'  error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

      section(class=' o-wrapper u-pb5')
        label(class='u-fw-bold u-color-primary u-block u-mb3 u-fz-h4') 4. Canal de respuesta

        div(class='u-flex u-flex-wrap u-mb3')
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='channel1' type='radio' name='channel' class='u-mr2', :value='1' v-model='form.responseChanelId')
            label(class='c-input__label' for='channel1') Personal
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='channel2' type='radio' name='channel' class='u-mr2', :value='2' v-model='form.responseChanelId')
            label(class='c-input__label' for='channel2') Correo Electrónico
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='channel3' type='radio' name='channel' class='u-mr2', :value='3' v-model='form.responseChanelId')
            label(class='c-input__label' for='channel3') Carta
          div(class='c-input c-input--secondary u-flex u-items-center u-px3 u-mb2')
            input(id='channel4' type='radio' name='channel' class='u-mr2', :value='4' v-model='form.responseChanelId')
            label(class='c-input__label' for='channel4') Teléfono

        div(class='u-center')
          button(class='u-fw-s-bold c-btn--primary u-px5' @click='postForm') Enviar Formulario
    app-footer
    loading(message='Enviando' v-if='isLoading')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'

  export default {
    name: 'ComplaintsScreen',
    data () {
      return {
        isShowModalConfirm: false,
        isShowModalError: false,
        toggleValidate: false,
        formValidate: false,
        clearForm: false,
        isLoading: false,
        form: {
          claimOptionId: 0,
          person: {
            fullname: '',
            legalName: '',
            address: '',
            district: '',
            province: '',
            region: '',
            identityDocument: '',
            phone: '',
            cellphone: '',
            email: '',
            parentsName: ''
          },
          itemOptionId: 0,
          descriptionItem: '',
          amount: '',
          details: '',
          order: '',
          document: {
            base64: '',
            extension: ''
          },
          responseChanelId: 0
        },
        rules: {
          claimOptionId: 'min:1',
          person: {
            fullname: 'required|name',
            legalName: 'required',
            address: 'required',
            district: 'required',
            province: 'required',
            region: 'required',
            identityDocument: 'required',
            phone: 'required|phone',
            cellphone: 'required|phone',
            email: 'required|email',
            parentsName: 'required'
          },
          itemOptionId: 'min:1',
          descriptionItem: 'required',
          amount: 'required',
          details: 'required',
          order: 'required',
          document: {
            base64: 'required',
            extension: 'required'
          },
          responseChanelId: 'min:1'
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`${window.API_URL}/claims`, this.form)
            .then((response) => {
              this.isShowModalConfirm = true
              this.isLoading = false
              this.form = {
                claimOptionId: 0,
                person: {
                  fullname: '',
                  legalName: '',
                  address: '',
                  district: '',
                  province: '',
                  region: '',
                  identityDocument: '',
                  phone: '',
                  cellphone: '',
                  email: '',
                  parentsName: ''
                },
                itemOptionId: 0,
                descriptionItem: '',
                amount: '',
                details: '',
                order: '',
                document: {
                  base64: '',
                  extension: ''
                },
                responseChanelId: 0
              }
              this.clearForm = !this.clearForm
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      },

      updateFile (file) {
        this.form.document = file
      },
      onVerify (value) {
        this.form.recaptcha = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Complaints/components/ComplaintsScreen.vue